'use client'

import * as React from 'react'

import { ThemeProvider as NextThemesProvider } from 'next-themes'

export function ThemeProvider({
  children,
  ...props
}: React.ComponentProps<typeof NextThemesProvider>) {
  // Silence React 19.2's "Encountered a script tag while rendering React
  // component" warning that next-themes' inline anti-flash <script> triggers
  // (next-themes 0.4.x has no opt-out for it). On the SERVER we leave the
  // script untyped so the browser executes it before first paint — that's what
  // prevents the theme flash. On the CLIENT we mark it type="application/json",
  // a non-executable type React doesn't flag. next-themes sets
  // suppressHydrationWarning on the element, so the differing attribute
  // reconciles silently. Drop this once next-themes ships a React-19.2-aware
  // release. See https://github.com/pacocoursey/next-themes/issues/387
  const scriptProps =
    typeof window === 'undefined'
      ? undefined
      : ({ type: 'application/json' } as const)

  return (
    <NextThemesProvider {...props} scriptProps={scriptProps}>
      {children}
    </NextThemesProvider>
  )
}
